import { useTheme } from '@emotion/react';

import type { IconComponent } from '@twistopayments/design-system/icons/constants';

import { Typography } from '../../../atoms/typography';
import { StepIconConnector } from '../step-icon-connector';
import { useStepIndex } from '../stepper/step-index.context';
import { useStepperConfig } from '../stepper/stepper-config.context';

import { useColor } from './color.hook';
import * as styles from './step-icon.styles';
import type { Color } from './types';

type Props = {
  color?: Color;
  customIcon?: IconComponent;
};

export const StepIcon = ({ color, customIcon }: Props) => {
  const theme = useTheme();
  const CustomIcon = customIcon;
  const { backgroundColor: iconBackgroundColor, textColor, iconColor } = useColor(color);
  const stepIndex = useStepIndex();
  const { backgroundColor: stepperBackgroundColor, iconRingColor } = useStepperConfig();

  return (
    <StepIconConnector>
      <div css={styles.container(theme, iconBackgroundColor, stepperBackgroundColor, iconRingColor)}>
        {CustomIcon !== undefined ? (
          <CustomIcon color={iconColor} css={styles.customIcon(theme)} />
        ) : (
          <Typography css={styles.text(textColor)} fontWeight="medium">
            {stepIndex}
          </Typography>
        )}
      </div>
    </StepIconConnector>
  );
};
